import { createAction, createAsyncThunk } from '@reduxjs/toolkit';
import { CompanyDetailsDto } from '../../api/ClientApi';
import { WarehouseClient } from '../../api/Extensions';
import { RootState } from '../reducers';
import { myAssert } from '../../common/console';

export const createNewDocumentCompanyDetail = createAction('companyDetails/createNewDocumentCompanyDetail');
export const createNewDocumentReceiverTemplate = createAction('companyDetails/createNewDocumentReceiverTemplate');
export const removeDocumentCompanyDetail = createAction<number>('companyDetails/removeDocumentCompanyDetail');
export const removeDocumentReceiverTemplate = createAction<number>('companyDetails/removeDocumentReceiverTemplate');
export const updateCompanyName = createAction<string>('companyDetails/updateCompanyName');
export const updateCurrency = createAction<string>('companyDetails/updateCurrency');
export const clearCompanyDetails = createAction('companyDetails/clearCompanyDetails');

export const updateLabelForDocumentCompanyDetail = createAction<{
    index: number;
    label?: string;
}>('companyDetails/updateLabelForDocumentCompanyDetail');

export const updateValueForDocumentCompanyDetail = createAction<{
    index: number;
    value?: string;
}>('companyDetails/updateValueForDocumentCompanyDetail');

export const updateLabelForDocumentReceiverTemplate = createAction<{
    index: number;
    label?: string;
}>('companyDetails/updateLabelForDocumentReceiverTemplate');

export const updateValueForDocumentReceiverTemplate = createAction<{
    index: number;
    value?: string;
}>('companyDetails/updateValueForDocumentReceiverTemplate');

export const setCompanyDetails = createAsyncThunk<CompanyDetailsDto, void>(
    'companyDetails/setCompanyDetails',
    async (payload: void, thunkAPI) => {
        return WarehouseClient.getMyCompanyDetails();
    },
);

export const saveCompanyDetails = createAsyncThunk<CompanyDetailsDto, void>(
    'companyDetails/saveCompanyDetails',
    async (payload: void, thunkAPI) => {
        const rootState = thunkAPI.getState() as RootState;
        const companyDetailsState = rootState.companyDetails;

        const companyDetails = companyDetailsState.companyDetails;
        const docCompDetails = companyDetailsState.docCompDetails;
        const docRecTemplate = companyDetailsState.docRecTemplate;

        myAssert(() => companyDetails !== null);

        if (companyDetails === null) {
            throw new Error();
        }

        const newCompDet = new CompanyDetailsDto();
        newCompDet.init(companyDetails);

        const compDetId: number | undefined = companyDetails.id;
        let savedCompDet: CompanyDetailsDto | undefined;

        let formattedDocCompDetails = {};

        if (!!docCompDetails) {
            let docCompDetailsString = '';
            docCompDetails.map((dcd) => {
                if (docCompDetailsString === '') {
                    docCompDetailsString += '{ ';
                }
                docCompDetailsString += '"' + dcd.label + '": "' + dcd.value + '",';
            });
            if (docCompDetailsString !== '') {
                docCompDetailsString = docCompDetailsString.slice(0, -1);
                docCompDetailsString += '}';

                formattedDocCompDetails = JSON.parse(docCompDetailsString);
            }
        }

        let formattedDocRecTemp = {};

        if (!!docRecTemplate) {
            let docRecTempString = '';
            docRecTemplate.map((drt) => {
                if (docRecTempString === '') {
                    docRecTempString += '{ ';
                }
                docRecTempString += '"' + drt.label + '": "' + drt.value + '",';
            });
            if (docRecTempString !== '') {
                docRecTempString = docRecTempString.slice(0, -1);
                docRecTempString += '}';

                formattedDocRecTemp = JSON.parse(docRecTempString);
            }
        }

        newCompDet.documentCompanyDetails = formattedDocCompDetails;
        newCompDet.documentReceiverTemplate = formattedDocRecTemp;

        if (!compDetId || compDetId <= 0) {
            const addCompanyDetailsPromise = WarehouseClient.addNewCompanyDetails(companyDetails as CompanyDetailsDto);

            savedCompDet = await addCompanyDetailsPromise;
        } else {
            myAssert(() => newCompDet.id !== undefined);

            if (newCompDet.id === undefined) {
                throw new Error();
            }

            const companyDetailsPromise = WarehouseClient.updateCompanyDetails(
                newCompDet.id,
                newCompDet as CompanyDetailsDto,
            );

            savedCompDet = await companyDetailsPromise;
        }

        return savedCompDet;
    },
    {
        condition: (payload: void, thunkAPI: { getState: any }) => {
            const companyDetailsState = (thunkAPI.getState() as RootState).companyDetails;

            return companyDetailsState.companyDetails !== null;
        },
    },
);
